import { String, Any, Record, Static } from '@sinclair/typebox';

export type AnyResponse = Static<typeof AnyResponse>;
export const AnyResponse = Record(String(), Any());
